export default {
  localStorageIntervalTime: 60 * 10,
  uploadFileMaxSizeSingle: 1000 * 1000 * 10,
  uploadFileMaxSizeTotal: 1000 * 1000 * 10 * 10,
  uploadFileAllowExtension: ["jpg", "jpeg", "gif", "bmp", "png", "zip"],
  code: {},
};
